module.exports = __webpack_public_path__ + "static/img/M-2.768737e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mga/M-2.png
// module id = xn9+
// module chunks = 0